import { render, staticRenderFns } from "./sendProHistory.vue?vue&type=template&id=4ca51672&scoped=true&"
import script from "./sendProHistory.vue?vue&type=script&lang=js&"
export * from "./sendProHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca51672",
  null
  
)

export default component.exports